import requests from "/src/utils/requests"
import permission from "./permission"
import sensitive from "./sensitive"

const getUserInfo = function (){
    // if(["mock"].indexOf(process.env.VUE_APP_MODE) > -1){
    //     return Promise.resolve({
    //         code: 0,
    //         data: {
    //             roles: {
    //                 menus: []
    //             },
    //         }
    //     })
    // }else{
    //     return requests({
    //         url: "/user/profile",
    //         method: "get",
    //     })
    // }
}

const login = ({ mobile, code })=> {
    return requests({
        url: "/user/login",
        method: "post",
        data: { mobile, pc:1, code }
    })
}

const sendMsg = ({ mobile})=> {
    return requests({
        url: "/sendSms",
        method: "post",
        data: { mobile,pc:1}
    })
}


const getUserDetail = function ({id}){
    return requests({
        url: `/user/userDetail`,
        method: "get",
        params: {
            id
        }
    })
}

const generateAccount = function ({mobile, tenantCode}){
    return requests({
        url: `/user/generateAccount`,
        method: "get",
        params: {
            mobile,
            tenantCode
        }
    })
}

const resetPassword = function ({id ,mobile}){
    return requests({
        url: `/user/resetPassword`,
        method: "put",
        data: {
            id,
            mobile,
        }
    })
}

const verifyPassword = function ({id , password}){
    return requests({
        url: `/user/verifyPassword`,
        method: "post",
        data: {
            id,
            password,
        }
    })
}

const logout = ()=> {
    return requests({
        url: "/user/logout",
        method: "get",
        params: {}
    })
}

export default {
    getUserInfo,
    login,
    getUserDetail,
    generateAccount,
    resetPassword,
    verifyPassword,
    ...permission,
    ...sensitive,
    logout,
	sendMsg
}